import React, { Suspense, lazy } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const About = lazy(() => import('../components/About'));
const Agenda = lazy(() => import('../components/Agenda'));
const Membership = lazy(() => import('../components/Membership'));
const Gallery = lazy(() => import('../components/Gallery'));

const LoadingSection = () => (
  <div className="min-h-[400px] flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-[#E37C64] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const MainLayout = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Suspense fallback={<LoadingSection />}>
        <About />
      </Suspense>
      <Suspense fallback={<LoadingSection />}>
        <Agenda />
      </Suspense>
      <Suspense fallback={<LoadingSection />}>
        <Membership />
      </Suspense>
      <Suspense fallback={<LoadingSection />}>
        <Gallery />
      </Suspense>
      <Footer />
    </div>
  );
};

export default MainLayout;